module.exports = __webpack_public_path__ + "img/asx_in.b4853617.jpg";